import moment from "moment";
import * as notify from "./notify";
import { multiply, isString } from "lodash";

export const objectToParamString = (data) => {
    // Usage: objectToParamString({ a: '1', b: '2', });
    // Returns: 'a=1&b=2'
    //
    // This also supports arrays:
    // objectToParamString({ a: ['1', '2']});
    // Returns: a=1&a=2
    return Object.keys(data)
        .reduce((arr, key) => {
            if (Array.isArray(data[key])) {
                for (var val of data[key]) {
                    arr.push(`${key}=${val}`);
                }

                return arr;
            }

            if (data[key] !== undefined || typeof data[key] === "boolean") {
                arr.push(`${key}=${data[key]}`);
            }

            return arr;
        }, [])
        .join("&");
};

export const arrayToParamString = (key, arr) => {
    // Usage: arrayToParamString('pid', ['1', '2',]);
    // Returns: 'pid=1&pid=2'
    return arr
        .map((value) => {
            return `${key}=${value}`;
        })
        .join("&");
};

export const getFilterParams = (filters, config, suppressError) => {
    const paramFiltered = filters.reduce((filterArr, filter) => {
        const id = filter.id.split(".").pop();
        let paramVal = "";
        switch (config[id]) {
            case "contains":
                paramVal = `contains(${id}, '${filter.value}')`;
                break;
            case "eq":
                paramVal = `${id} eq ${filter.value}`;
                break;
            case "ne":
                paramVal = `${id} ne ${filter.value}`;
                break;
            case "gt":
                paramVal = `${id} gt ${filter.value}`;
                break;
            case "lt":
                paramVal = `${id} gt ${filter.value}`;
                break;
            case "guid":
                if (filter.value.length === 36) {
                    paramVal = `${id} eq ${filter.value}`;
                } else {
                    !suppressError && notify.warning(`${id} requires a 36 character GUID to filter`);
                }

                break;
            case "date":
                if (filter.value) {
                    const arr = [];

                    if (filter.value.filterFromDate) {
                        const fromMoment = moment(filter.value.filterFromDate).utc(false).startOf("day").format();
                        arr.push(`${id} gt ${encodeURIComponent(fromMoment)}`);
                    }

                    if (filter.value.filterToDate) {
                        const toMoment = moment(filter.value.filterToDate).utc(false).endOf("day").format();
                        arr.push(`${id} lt ${encodeURIComponent(toMoment)}`);
                    }

                    paramVal = arr.join(" AND ");
                }

                break;
            default:
                paramVal = `startswith(${id}, '${filter.value}')`;
        }

        if (paramVal) {
            filterArr.push(paramVal);
        }

        return filterArr;
    }, []);

    return paramFiltered.length > 0 ? `&filter=${paramFiltered.join(" AND ")}` : "";
};

export const getSortParams = (sorts) => {
    const paramSorted = sorts.map((sort) => {
        let id = sort.id.split(".").pop();

        if (id === "assignedUserInfo") {
            id = "fullName";
        }

        if (id === "assignmentGroupKey") {
            id = "assignmentGroupName";
        }

        const ascDesc = sort.desc ? "desc" : "asc";

        return `${id} ${ascDesc}`;
    });

    return paramSorted.length > 0 ? `&sortBy=${paramSorted.join(",")}` : "";
};

export const isLightColor = (color) => {
    var r, g, b, hsp;

    if (color.match(/^rgb/)) {
        color = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);

        r = color[1];
        g = color[2];
        b = color[3];
    } else {
        color = +("0x" + color.slice(1).replace(color.length < 5 && /./g, "$&$&"));

        r = color >> 16;
        //eslint-disable-next-line
        g = (color >> 8) & 255;
        b = color & 255;
    }

    hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));

    return hsp > 127.5;
};

export function isFunction(functionToCheck) {
    return functionToCheck && {}.toString.call(functionToCheck) === "[object Function]";
}

export const scrollToId = (id, offsetOverride) => {
    const el = document.getElementById(id);
    // move scrollTo to the end of event loop query (to be ensured that tab is opened)
    setTimeout(() => {
        window.scrollTo({
            top: offsetOverride ? offsetOverride : el.offsetTop - 70 || 0,
            behavior: "smooth",
        });
    });
};

export function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

export const arrayToObjectByKey = (data, key) => {
    return data
        ? data.reduce((obj, i) => {
              obj[i[key]] = i;

              return obj;
          }, {})
        : {};
};

export const guidGenerator = () => {
    var S4 = function () {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    };

    return S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4();
};

export const isBoolean = (value) => {
    return typeof value === "boolean";
};

export const isMacOs = () => navigator.userAgent.indexOf("Mac OS X") !== -1;

export const transformUnit = (weight, unitConverter) => {
    if (!weight) {
        return 0;
    }

    const value = typeof weight === "number" ? weight : Number(weight.replace(",", "."));

    return multiply(value, unitConverter);
};

export const transformDimension = (dimension) => {
    if (!dimension || dimension === "null") {
        return;
    }

    const convertedDimension = isString(dimension) ? Number(dimension.replace(",", ".")) : dimension;

    return convertedDimension.toFixed(2);
};
